import React from 'react';
import { Flex, Box, Text } from 'rebass/styled-components';
import { ProfilePicture } from '@getro/rombo';
import PropTypes from 'prop-types';

export const CandidateCompanyRenderer = ({ data }) => {
  const { original } = data;

  if (!original.companyName) return null;

  return (
    <Flex alignItems="center" sx={{ gap: '8px', p: '8px' }} color="text.main">
      <Box width="24px" height="24px" sx={{ flexShrink: 0 }}>
        <ProfilePicture variant="square" imageUrl={original.companyLogoUrl} title={original.companyName} />
      </Box>
      <Text color="text.main" fontSize="14px">
        {original.companyName}
      </Text>
    </Flex>
  );
};

CandidateCompanyRenderer.propTypes = {
  data: PropTypes.object,
};

CandidateCompanyRenderer.defaultProps = {
  data: {},
};
